import "./style.scss";

import { useAuthenticator } from "@aws-amplify/ui-react";
import { CheckOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { sendPaywallDemand } from "store/slackStore";
import type { RootState } from "store/store";
import { useAppDispatch } from "store/store";

import imgPaywall from "./../../../../assets/img/png/VisualArea.png";

const PaywallAccessToPortal = () => {
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const { companySettings } = useSelector((state: RootState) => state.settings);
    const { paywalDemandStatus } = useSelector((state: RootState) => state.slack);
    const { user } = useAuthenticator((context) => [context.user]);

    const handleSlackMessage = () => {
        const payload = {
            blocks: [
                {
                    type: "header",
                    text: {
                        type: "plain_text",
                        text: ":point_right: Requête paywall : demande d'adhésion d'un éditeur",
                        emoji: true,
                    },
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: `L'entreprise ${companySettings?.name ?? "-"} *(initié par ${
                            user.attributes?.name ? user.attributes?.name : "-"
                        })* est intéressée par l'espace auteur et souhaiterait être recontactée.`,
                    },
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: `*Informations*\n>Numéro de téléphone : ${
                            companySettings?.phoneNumber ?? "-"
                        } \n>Adresse e-mail : ${user.attributes?.email ?? "-"}`,
                    },
                },
            ],
        };
        dispatch(sendPaywallDemand(payload));
    };

    return (
        <div className="paywall-access-portal">
            <div className="paywall-access-body">
                <img src={imgPaywall} alt="paywall" />
                <h3>{t("Beneficiars.PaywallInvitation.Title")}</h3>
                <div className="container-infos">
                    <span>
                        <CheckOutlined />
                        {t("Beneficiars.PaywallInvitation.Advantage1")}
                    </span>
                    <span>
                        <CheckOutlined />
                        {t("Beneficiars.PaywallInvitation.Advantage2")}
                    </span>
                    <span>
                        <CheckOutlined />
                        {t("Beneficiars.PaywallInvitation.Advantage3")}
                    </span>
                </div>
                {paywalDemandStatus === "succeeded" ? (
                    <div className="container-result">
                        <p>{t("Beneficiars.PaywallInvitation.ResultAction1")}</p>
                        <p>{t("Beneficiars.PaywallInvitation.ResultAction2")}</p>
                        <p className="grey">{t("Beneficiars.PaywallInvitation.ResultAction3")}</p>
                    </div>
                ) : (
                    <div className="container-actions">
                        <a
                            className="meet"
                            target="_blank"
                            href="https://calendly.com/denise-crealo/demo-crealo-droits-d-auteur-espace-auteur"
                            rel="noreferrer"
                        >
                            {t("Beneficiars.PaywallInvitation.MeetUp")}
                        </a>
                        <button className="contact" onClick={() => handleSlackMessage()}>
                            {t("Beneficiars.PaywallInvitation.ContactMe")}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaywallAccessToPortal;
